import { ref } from 'vue'

export function useGeolocation($googleMapsLoader) {
  const position = ref(null)
  const address = ref(null)
  const error = ref(null)

  function getCurrentPosition() {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        error.value = 'Geolocalización no soportada'
        reject(error.value)
        return
      }
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          position.value = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude
          }
          resolve(position.value)
        },
        (err) => {
          error.value = err.message
          reject(error.value)
        }
      )
    })
  }

  async function getAddressFromPosition(pos) {
    if (!$googleMapsLoader) {
      error.value = 'Google Maps Loader no disponible'
      return null
    }
    const google = await $googleMapsLoader.load()
    return new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode({ location: pos }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          address.value = {
            formatted_address: results[0].formatted_address,
            address_components: results[0].address_components,
            address_format: getFormatAddressData(results[0].address_components)
          }
          resolve(address.value)
        } else {
          error.value = 'No se pudo obtener la dirección'
          reject(error.value)
        }
      })
    })
  }

  function getFormatAddressData(address_components) {
    const address = {
      street_number: '',
      route: '',
      locality: '',
      sublocality: '',
      political: '',
      sublocality_level_1: '',
      neighborhood: '',
      postal_code: ''
    }

    address_components.forEach((component) => {
      const componentType = component.types[0]
      if (address[componentType] !== undefined) {
        address[componentType] = component.long_name
      }
    })

    return {
      city: address.locality,
      street: address.route,
      num: address.street_number,
      suburb:
        address.sublocality ||
        address.political ||
        address.sublocality_level_1 ||
        address.neighborhood,
      zip: address.postal_code
    }
  }

  function getNearestOffice(userLocation, offices) {
    if (!userLocation || !offices || offices.length === 0) return null

    function haversineDistance(lat1, lng1, lat2, lng2) {
      const toRad = (x) => (x * Math.PI) / 180
      const R = 6371 // km
      const dLat = toRad(lat2 - lat1)
      const dLng = toRad(lng2 - lng1)
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return R * c
    }

    let nearest = offices[0]
    let minDist = haversineDistance(
      userLocation.lat,
      userLocation.lng,
      offices[0].location.lat,
      offices[0].location.lng
    )

    for (let i = 1; i < offices.length; i++) {
      const dist = haversineDistance(
        userLocation.lat,
        userLocation.lng,
        offices[i].location.lat,
        offices[i].location.lng
      )
      if (dist < minDist) {
        minDist = dist
        nearest = offices[i]
      }
    }
    return nearest
  }

  return {
    getNearestOffice,
    position,
    address,
    error,
    getCurrentPosition,
    getAddressFromPosition
  }
}
